import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mb-24" }
const _hoisted_3 = { class: "d-flex justify-content-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-add me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "container bg-white rounded-1 p-16"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_professional_expedient_forms_list = _resolveComponent("the-professional-expedient-forms-list")!
  const _component_the_professional_expedient_measures_list = _resolveComponent("the-professional-expedient-measures-list")!
  const _component_the_professional_expedient_forms_create_modal = _resolveComponent("the-professional-expedient-forms-create-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!!_ctx.currentExpedient.rgpdConfirmedAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formsSettings.forms, (field, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (!_ctx.specialForms.includes(field.type))
                  ? (_openBlock(), _createBlock(_component_v_button, {
                      key: 0,
                      variant: "filter",
                      class: _normalizeClass(["me-8 mb-8 mb-lg-0", {'active': _ctx.medicalData === _ctx.parseField(field).key }]),
                      "aria-label": _ctx.$t(_ctx.parseField(field).label),
                      onClick: ($event: any) => (_ctx.setMedicalData(_ctx.parseField(field).key))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.parseField(field).label)), 1)
                      ]),
                      _: 2
                    }, 1032, ["class", "aria-label", "onClick"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            _createVNode(_component_v_button, {
              variant: "filter",
              class: _normalizeClass(["me-8", {'active': _ctx.medicalData === 'medidas' }]),
              "aria-label": _ctx.$t('Medidas'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMedicalData('medidas')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Medidas')), 1)
              ]),
              _: 1
            }, 8, ["class", "aria-label"])
          ]),
          (!_ctx.specialForms.includes(_ctx.medicalData))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_the_professional_expedient_forms_list, {
                  ref: "the-professional-expedient-forms-list",
                  "form-name": _ctx.medicalData,
                  "form-data": _ctx.expedientForm,
                  "force-save": false,
                  onLoadExpedientFormsRequested: _ctx.loadExpedientForms,
                  onShowFormCreateModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalToShow = 'the-professional-expedient-forms-create-modal'))
                }, null, 8, ["form-name", "form-data", "onLoadExpedientFormsRequested"]),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.can('professional.expedient.form.store'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        variant: "secondary",
                        "aria-label": _ctx.$t('Añadir {medicalData}', { medicalData: _ctx.$t(_ctx.medicalData) }),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalToShow = 'the-professional-expedient-forms-create-modal'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _createTextVNode(_toDisplayString(_ctx.$t('Añadir')) + " " + _toDisplayString(_ctx.$t(_ctx.medicalData)), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : (_openBlock(), _createBlock(_component_the_professional_expedient_measures_list, { key: 1 }))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('Politicas RGPD no aceptadas en el expediente')), 1)),
    (_ctx.modalToShow === 'the-professional-expedient-forms-create-modal')
      ? (_openBlock(), _createBlock(_component_the_professional_expedient_forms_create_modal, {
          key: 2,
          "form-name": _ctx.medicalData,
          "form-structure": _ctx.lastFormStructure,
          onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalToShow = null)),
          onCreateFormRequested: _ctx.createExpedientForm
        }, null, 8, ["form-name", "form-structure", "onCreateFormRequested"]))
      : _createCommentVNode("", true)
  ], 64))
}